import React from "react";
import DocumentContent from "../../../../components/Manage/ViewContent/DocumentContent/DocumentContent";
import ScormContent from "../../../../components/Manage/ViewContent/ScormContent/ScormContent";
import VideoContent from "../../../../components/Manage/ViewContent/VideoContent/VideoContent";
import classes from "./ViewContent.module.scss";

const ViewContent = ({ viewContent = true, shotclassData }) => {
  return (
    <div className={classes.viewContent}>
      {viewContent ? (
        shotclassData?.Mediatype === 1 ? (
          <VideoContent shotclassData={shotclassData} />
        ) : shotclassData?.Mediatype === 2 ||
          shotclassData?.Mediatype === 3 ||
          shotclassData?.Mediatype === 5 ||
          shotclassData?.Mediatype === 7 ? (
          <DocumentContent shotclassData={shotclassData} />
        ) : shotclassData?.Mediatype === 9 ? (
          <ScormContent shotclassData={shotclassData} />
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default ViewContent;
